export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/hire-banner-tag-m-10b3ed7d7ead3655d7763949fab96c00.png";